import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-video-card',
  styleUrls: ['./video-card.component.scss'],
  templateUrl: './video-card.component.html',
})
export class VideoCardComponent {
  @Input() video: any;
}
